module.exports = __webpack_public_path__ + "img/messenger-banner-img-ua.ced4bfe6.png";